import { enumValues } from '@w/db/sqlite'

export const flashcardImportanceCodes = {
  low: 0,
  medium: 1,
  high: 2,
} as const
export const flashcardImportanceValues = enumValues(flashcardImportanceCodes)
export const flashcardDifficultyCodes = {
  low: 0,
  medium: 1,
  high: 2,
} as const
export const flashcardDifficultyValues = enumValues(flashcardDifficultyCodes)
export const flashcardPromptTypeCodes = {
  recall: 0,
  application: 1,
  retention: 2,
} as const
export const flashcardPromptTypeValues = enumValues(flashcardPromptTypeCodes)
// The code IS the sitting order (decision 6). Form recall leads: the learner
// produces the word first, while it is hardest and they are freshest.
export const cardKindCodes = {
  formRecall: 0,
  senseRecall: 1,
  formRecallParadigmCell: 2,
  dictation: 3,
  readAloud: 4,
} as const
export const cardKindValues = enumValues(cardKindCodes)
export type CardKind = (typeof cardKindValues)[number]
export type FlashcardPromptType = (typeof flashcardPromptTypeValues)[number]
export { reviewEventSchema as flashcardEventDataSchema } from '../../db/card-history'

export type { Flashcard, FlashcardInsert, FlashcardEvent, FlashcardEventInsert } from '../../db/schema'

